import React from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import Household from 'Classes/Household';
import PropTypes from 'prop-types';
import { LiabilitiesPicker } from 'Components/Universal/Questionnaire/Sections/Pickers';
import Navigator from '../UI/Navigator';

const Liabilities = ({ household }) => (
  <Navigator>
    <LiabilitiesPicker householdId={household.id} />
  </Navigator>
);

Liabilities.propTypes = {
  household: PropTypes.instanceOf(Household).isRequired,
};

export default withHousehold(Liabilities);
